// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { getSlideFieldDefinitions, SlideOwnProps, SlideStyles } from "@store/Library/Widgets/Basic/Slide";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import React from "react";
import { css } from "styled-components";

const SlideWidget = getWidgetComponent("Basic/Slide");

export const slideStyles: SlideStyles = {
    headingText: {
        css: css`
            text-transform: uppercase;
        `,
    },
    subheadingText: {
        css: css`
            ${({ theme }) => css`
                font-weight: ${theme.design.typography.weight.bold};
            `}
        `,
    },
    slideContentWrapper: {
        css: css`
            font-size: 14px;
        `,
    },
};

const styles = slideStyles;

export const PromoTile = ({ fields }: SlideOwnProps) => {
    const extendedProps = {
        fields: {
            ...fields,
            background: "color",
            backgroundColor: "#f3f3f3",
            headingStyle: "h3",
            headingColor: "accent.main",
            subheadingColor: "text.main",
            textColor: "text.main",
            contentMobileWidth: "60%",
            contentTabletWidth: "60%",
            contentDesktopWidth: "60%",
            contentPadding: 24,
        },
    };

    return (
        <SlideWidget
            {...extendedProps}
            extendedStyles={{
                ...styles,
            }}
        />
    );
};

const widgetModule: WidgetModule = {
    component: PromoTile,
    definition: {
        group: "Basic",
        icon: "presentation-screen",
        fieldDefinitions: getSlideFieldDefinitions({
            verticalAlign: true,
            contentPositionLeftRight: true,
            textAlign: true,
            clickableSlide: true,
            image: true,
            imageLargeResolution: true,
            heading: true,
            subheading: true,
            text: true,
            buttonLabel: true,
            buttonLink: true,
        }),
    },
};

export default widgetModule;
